const backendUrl: any = import.meta.env.VITE_REACT_APP_BACKENDCOREURL == null ? "" : import.meta.env.VITE_REACT_APP_BACKENDCOREURL;
const backendAdminUrl: any = import.meta.env.VITE_REACT_APP_BACKENDADMINURL == null ? "" : import.meta.env.VITE_REACT_APP_BACKENDADMINURL;
console.log("bckend core env " + backendUrl);
console.log("bckend admin env " + backendAdminUrl);
const ServiceEndpoints = {

  // User info
  FetchUserInfo: backendUrl + "/api/UserRole/GetUserRoles",
  FetchUserPhoto: "https://graph.microsoft.com/v1.0/me/photo/$value",

  // Active requests

  FetchActiveRequests: backendUrl + "/api/Requests/Active/GetActiveRequests",

  FetchActiveMetrics: backendUrl + "/api/Requests/GetActiveMetrics",

  FetchTabMetrics: backendUrl + "/api/Requests/GetTabMetrics",

  FetchActiveRequestById: backendUrl + "/api/Requests/GetRequestsById?id=",

  ExportToExcelActiveRequests: backendUrl + "/api/Requests/Active/ExportToExcelActiveRequests",

  ExportToExcelOutgoingRequests: backendUrl + "/api/Requests/Outgoing/ExportToExcelOutgoingRequests",

  ExportToExcelIncomingRequests: backendUrl + "/api/Requests/Incoming/ExportToExcelIncomingRequests",

  ExportToExcelDraftRequests: backendUrl + "/api/Requests/Draft/ExportToExcelDraftRequests",

  FetchIncomingRequests: backendUrl + "/api/Requests/Incoming/GetIncomingRequests",

  ExcelExportIncomingRequests: backendUrl + "/api/Requests/Incoming/ExportToExcel",

  FetchOutgoingRequests: backendUrl + "/api/Requests/Outgoing/GetOutgoingRequests",

  FetchDraftRequests: backendUrl + "/api/Requests/Draft/GetDraftRequests",

  DeleteDraftRequest: backendUrl + "/api/Requests/Draft/DeleteDraftRequest?id=",

  CancelOutgoingRequest: backendUrl + "/api/Requests/Outgoing/CancelRequest",

  SendReminderToCA: backendUrl + "/api/Requests/Outgoing/SendReminder?id=",

  FetchNewRequestInfoById: backendUrl + "/api/NewRequest/GetNewRequest/",

  CreateNewRequest: backendUrl + "/api/NewRequest/CreateRequest/",

  UpdateDraftRequest: backendUrl + "/api/NewRequest/UpdateRequest/",

  FetchWorkflowHistoyById: backendUrl + "/api/WorkflowHistory/GetWorkflowHistoryById?id=",

  UpdateCaResponse: backendUrl + "/api/Requests/UpdateCaResponse?id=",
  GenerateReport: backendUrl + "/api/Requests/ExportToPDf?id=",



  //Admin euslb

  FetchAllEUSLB: backendAdminUrl + "/api/admin/EUSLB/GetAllEUSLB",
  DeleteEUSLBById: backendAdminUrl + "/api/admin/EUSLB/DeleteEUSLB",
  UpdateEUSLBById: backendAdminUrl + "/api/admin/EUSLB/UpdateEUSLB",
  CreateEUSLB: backendAdminUrl + "/api/admin/EUSLB/CreateEUSLB",
  FetchReminder: backendAdminUrl + "/api/admin/Reminder/GetReminderTPL",
  UpdateReminder: backendAdminUrl + "/api/admin/Reminder/UpdateMailBody",
  FetchAllPeriods: backendAdminUrl + "/api/admin/Periods/GetAllPeriods",
  UpdatePeriods: backendAdminUrl + "/api/admin/Periods/UpdatePeriods",
  FetchFieldGuidance: backendAdminUrl + "/api/admin/FieldGuidance/GetFieldGuidance",
  UpdateFieldGuidance: backendAdminUrl + "/api/admin/FieldGuidance/UpdateFieldGuidance",

  // Core field guidance (read-only, for user-facing tooltips)
  FetchCoreFieldGuidance: backendUrl + "/api/FieldGuidance/GetFieldGuidance",

  // Admin POI Search Scenarios

  FetchNaturalSearchScenarios: backendAdminUrl + "/api/admin/SearchScenarios/GetNaturalScenarios",
  FetchLegalSearchScenarios: backendAdminUrl + "/api/admin/SearchScenarios/GetLegalScenarios",
  AddSearchScenario: backendAdminUrl + "/api/admin/SearchScenarios/AddSearchScenario",
  EditSearchScenario: backendAdminUrl + "/api/admin/SearchScenarios/EditSearchScenario",
  DeleteSearchScenario: backendAdminUrl + "/api/admin/SearchScenarios/DeleteSearchScenario",

  // Manage System Data
  GetEndOfHistoricalPeriod: backendAdminUrl + "/api/admin/PersonOfInterest/GetEndOfHistoricalPeriod",
  FetchAllPOI: backendAdminUrl + "/api/admin/PersonOfInterest/GetAllPersonOfInterest?typeId=",
  FetchPOIById: backendAdminUrl + "/api/admin/PersonOfInterest/GetPersonOfInterestById",
  CheckPOIAssessmentsById: backendAdminUrl + "/api/admin/PersonOfInterest/CheckPersonOfInterestAssessmentsById",
  UpdatePOIById: backendAdminUrl + "/api/admin/PersonOfInterest/UpdatePersonOfInterest",
  CreatePOI: backendAdminUrl + "/api/admin/PersonOfInterest/CreatePersonOfInterest",
  CreatePOIorFetch: backendAdminUrl + "/api/admin/PersonOfInterest/CreatePersonOfInterestOrFetch",
  DeletePOIById: backendAdminUrl + "/api/admin/PersonOfInterest/DeletePersonOfInterest",
  DownloadAllUploadedData: backendAdminUrl + "/api/admin/PersonOfInterest/DownloadAllUploadedData",
  FetchAssessmentByPoiId: backendAdminUrl + "/api/admin/Assessment/GetAssessmentByPoiId",
  UpdateAssessmentById: backendAdminUrl + "/api/admin/Assessment/UpdateAssessment",
  CreateAssessment: backendAdminUrl + "/api/admin/Assessment/CreateAssessment",
  DeleteAssessmentById: backendAdminUrl + "/api/admin/Assessment/DeleteAssessment",
  FetchAllCP: backendAdminUrl + "/api/admin/ContactPerson/GetAllContactPerson",
  FetchCPByMail: backendAdminUrl + "/api/admin/ContactPerson/GetContactPersonByMail",
  UpdateContactById: backendAdminUrl + "/api/admin/ContactPerson/UpdateContactPerson",
  CreateContact: backendAdminUrl + "/api/admin/ContactPerson/CreateContactPerson",
  DeleteContactById: backendAdminUrl + "/api/admin/ContactPerson/DeleteContactPerson",
  BulkUpload: backendAdminUrl + "/api/admin/BulkUpload/BulkUpload",
  BulkUploadHistorical: backendAdminUrl + "/api/admin/BulkUpload/BulkUploadHistorical",
  BulkUploadHist: backendAdminUrl + "/api/admin/BulkUpload/BulkUploadHistorical",
  UpdateIndexRecord: backendUrl + "/api/Search/UpdateIndexRecord",
  ConvertForIndex: backendAdminUrl + "/api/admin/PersonOfInterest/ConvertForIndex",
  EmailConfiguration: backendAdminUrl + "/api/admin/SharedEmails/UpdateSharedEmails",
  FetchEmailConfiguration: backendAdminUrl + "/api/admin/SharedEmails/GetSharedEmails",
  GetTotalAssessmentsForDeletion: backendAdminUrl + "/api/admin/Assessment/GetTotalAssessmentsForDeletion",
  BulkDeleteAssessments: backendAdminUrl + "/api/admin/Assessment/BulkDeleteAssessments",
  DownloadAssessmentsForDeletion: backendAdminUrl + "/api/admin/Assessment/DownloadAssessmentsForDeletion",

  // Search
  Search: backendUrl + "/api/Search/SearchPersonOfInterest",
  SearchContacts: backendUrl + "/api/Search/SearchContact",
  SearchContactCountries: backendUrl + "/api/Search/GetDistinctCountries",
  SeachContactAuthorities: backendUrl + "/api/Search/GetDistinctAuthorities",

  // Assessment
  Assessment: backendUrl + "/api/Assessments/GetAssessmentsByPoiId?id=",
  FilteredAssement: backendUrl + "/api/Assessments/GetFilteredAssessmentsByPoiId?id=",
  StatusAssessment: backendUrl + "/api/Assessments/GetAssessmentStatusByPoiId?id=",

  // Countries and Authorities
  FetchRequestFilterOptions: backendUrl + "/api/Requests/GetRequestFilterOptions",

  // View uploaded records
  FetchFilesUploaded: backendUrl + "/api/FileUploads/GetFileUploads",

  // View validation results
  FetchValidationResults: backendUrl + "/api/FileUploads/GetErrorCsvRecordsByFileId?id=",
  ExportToExcelValidationResults: backendUrl + "/api/FileUploads/GetCsvByFileId?id=",

  // Version information
  FetchVersionInfo: backendUrl + "/api/Version",

  // App settings
  FetchAppSettings: backendUrl + "/api/AppSettings",

  // CA End User Legal Basis Assignment
  FetchCAEndUserAssignments: backendUrl + "/api/CAEndUserLegalBasisAssignment",
  FetchAvailableCAEndUsers: backendUrl + "/api/CAEndUserLegalBasisAssignment/available-users",
  FetchActiveLegalBases: backendUrl + "/api/CAEndUserLegalBasisAssignment/legal-bases",
  CreateCAEndUserAssignment: backendUrl + "/api/CAEndUserLegalBasisAssignment",
  UpdateCAEndUserAssignment: backendUrl + "/api/CAEndUserLegalBasisAssignment",
  DeleteCAEndUserAssignment: backendUrl + "/api/CAEndUserLegalBasisAssignment",
  FetchUsersAssignedToLegalBasis: backendUrl + "/api/CAEndUserLegalBasisAssignment/by-legal-basis",
}
export default ServiceEndpoints;
